const fftSize = 64;

export function visualiser(audioElement) {

  let audioSource = null;
  let analyser = null;
  let gainNode = null;

  // the number of data values that dictate the number of bars in the canvas. Always exactly one half of the fft size
  const bufferLength = fftSize / 2;
  // coverting to unsigned 8-bit integer array format because that's the format we need
  const dataArray = new Uint8Array(bufferLength);

  function setup() {

    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();

    // creates an audio node from the audio source
    audioSource = audioCtx.createMediaElementSource(audioElement);
    // creates an audio node for analysing the audio data for time and frequency
    analyser = audioCtx.createAnalyser();
    
    // for controlling volume
    gainNode = audioCtx.createGain();

    // connects the audio source to the analyser. Now this analyser can explore and analyse the audio data for time and frequency
    audioSource.connect(analyser);
    
    analyser.connect(gainNode);
    gainNode.gain.value = 1;
    
    // connects the gainNode to the destination. This is the speakers
    gainNode.connect(audioCtx.destination);

    // controls the size of the FFT. The FFT is a fast fourier transform. Basically the number of sound samples. Will be used to draw bars in the canvas
    analyser.fftSize = fftSize;

  }

  function toggleMute(forcedStatus) {
    let isMuted = true;
    if (gainNode) {
      let muted = gainNode.gain.value === 0;
      if (forcedStatus !== undefined) {
        muted = forcedStatus;
      }
      gainNode.gain.value = muted ? 1 : 0;
      isMuted = !muted;
    }
    return isMuted;
  }

  function getData() {
    if (!analyser) {
      return null;
    }

    // copies the frequency data into the dataArray in place. Each item contains a number between 0 and 255
    analyser.getByteFrequencyData(dataArray);

    const waveform = Array.from(dataArray).map(i => (i / 255));

    // const volume = waveform[20];
    // const volume = Math.max(...dataArray);
    const volume = dataArray.reduce((acc, curr) => {
      return (acc + curr);
    }, 0) / (255 * fftSize * 0.5);
  
    return {
      waveform,
      volume
    }
  }


  return {
    setup,
    getData,
    toggleMute
  };
}
